import * as $ from 'jquery';
import {delineate} from "../../lib/delineate";
// import "../../lib/objectFitPolyfill.min.js";
import * as CollectionCarousel from "../modules/collectionCarousel";
import * as ProductMedia from "../modules/productMedia";
import {throttle} from "throttle-debounce";
import {update} from "../modules/rangeSlider";


namespace PFF.controllers.productDetail {

	function printFunctionalityInit() {
		$('.js-window-print').on('click', function(){
			window.print();
		});
	}

	function delineateInfoBar(){
		new delineate('.js-info-bar');
	}

	function writeReviewTrigger() {
		//unbinding third party js
	
		$(document).on('mousedown', '.bv_aaq_button', function() {
            // Switch to the QA tab in the Reviews / QA tabset
            $('#toggle-qa').get(0).dispatchEvent(new Event('click'));
        });

        $(document).on('mousedown', '.bv_war_button', function() {
            // Switch to the QA tab in the Reviews / QA tabset
            $('#toggle-reviews').get(0).dispatchEvent(new Event('click'));
        });

        $(document).on('mousedown', '.bv_ratings_summary', function() {
            // Switch to the QA tab in the Reviews / QA tabset
            $('#toggle-reviews').get(0).dispatchEvent(new Event('click'));
        });

	}

	function initProductInfoBar() {
		let $productInfoBar = $('.js-product-info-bar');
		let $sectionNav = $('.js-section-nav');
		if(!$productInfoBar.length) {
			return
		}

		let $window = $(window);

		let updateInfoBarVisibility = function() {
			if ($window.scrollTop() >= $sectionNav.offset().top) {
				$sectionNav.addClass('state-stuck');
			} else {
				$sectionNav.removeClass('state-stuck');
			}
		}

		updateInfoBarVisibility();

		$window.on('scroll', function () {
			throttle(150, updateInfoBarVisibility() );
		}).on('resize', function () {
			throttle( 150, updateInfoBarVisibility() );
		});
	}

	export function init() {
		printFunctionalityInit();
		delineateInfoBar();	
		initProductInfoBar();
		CollectionCarousel.init();
		//Stickyfill.init();
		ProductMedia.init();
		writeReviewTrigger();
	}
}

PFF.controllers.productDetail.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/productDetail.ts